import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStaffInventoryData } from '../types';

export const GET_STAFF_INVENTORY: TypedDocumentNode<IGetStaffInventoryData> = gql`
  query getStaffInventory {
    viewer {
      id
      site {
        id
        inventory {
          email
          firstName
          id
          lastName
          phone
          role
        }
      }
    }
  }
`;
